import { render } from "./CarouselView.vue?vue&type=template&id=b35a67a2"
import script from "./CarouselView.vue?vue&type=script&lang=js"
export * from "./CarouselView.vue?vue&type=script&lang=js"

import "./CarouselView.vue?vue&type=style&index=0&id=b35a67a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__